module.exports = __webpack_public_path__ + "img/14_1.f3ccc107.jpg";